import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../common/Translate';

const svgStyle = {
  width: '100%',
  marginTop: '1rem',
  marginBottom: '1rem',
};

const Rotation = ({ salesSpeed, rotationDays }) => {
  let cursorPosition = '';
  let rotationName = '';
  switch (salesSpeed) {
    case 0:
    case 1:
      cursorPosition = 'translate(-1440 -196.6)';
      rotationName = 'fast';
      break;
    case 2:
    case 3:
      cursorPosition = 'translate(-1250 -196.6)';
      rotationName = 'normal';
      break;
    case 4:
    case 9:
      cursorPosition = 'translate(-1060 -196.6)';
      rotationName = 'slow';
      break;
    default:
      cursorPosition = false;
      break;
  }
  return (
    <div>
      <h5>{t(rotationName)}</h5>
      <p>
        {rotationDays} {t('rotationDays')}
      </p>
      <svg xmlns="http://www.w3.org/2000/svg" width="576" height="46.018" viewBox="0 0 576 46.018" style={svgStyle}>
        <g transform="translate(-34 -1081)">
          {cursorPosition && (
            <path d="M1557.527,1323.618l13.673-13.672,13.672,13.672Z" transform={cursorPosition} fill="#4b4b4b" />
          )}
          <path
            d="M12.726,0H192a0,0,0,0,1,0,0V25.453a0,0,0,0,1,0,0H12.726A12.726,12.726,0,0,1,0,12.726v0A12.726,12.726,0,0,1,12.726,0Z"
            transform="translate(34 1081)"
            fill="#1ce648"
            opacity="0.7"
          />
          <path
            d="M12.726,0H192a0,0,0,0,1,0,0V25.453a0,0,0,0,1,0,0H12.726A12.726,12.726,0,0,1,0,12.726v0A12.726,12.726,0,0,1,12.726,0Z"
            transform="translate(606.935 1106.453) rotate(180)"
            fill="#eb3d09"
            opacity="0.7"
          />
          <rect width="192" height="25.453" transform="translate(222.612 1081)" fill="#ffe200" />
          <g transform="translate(34 1081)" fill="none" stroke="#f4f4f4" strokeWidth="3">
            <rect width="576" height="27.453" rx="13.726" stroke="none" />
            <rect x="1.5" y="1.5" width="573" height="24.453" rx="12.226" fill="none" />
          </g>
        </g>
      </svg>
      <p className=" small text-secondary">
        {t('Valuation_date')} {new Date().toLocaleDateString()}
      </p>
    </div>
  );
};

export default Rotation;

Rotation.propTypes = {
  salesSpeed: PropTypes.number.isRequired,
  rotationDays: PropTypes.number.isRequired,
};
